'use client'; // Error components must be Client Components

import { useEffect } from 'react';
import { useRollbar } from '@rollbar/react';

import reportErrorDebounced from '@hub/common/src/reportErrorDebounced';
import { getLogger } from '@hub/common/src/logger';

import Navbar from '@/components/Navbar';
import ErrorMessage from '@hub/common-components/src/ErrorMessage';
import { useCitOriginClient } from '@hub/common-components/src/CitOriginClientProvider';

// catches all unhandled errors in the app
export default function Error({ error, _reset }: { error: Error; _reset: () => void }) {
  const rollbar = useRollbar();
  const citOrigin = useCitOriginClient();
  const logger = getLogger(citOrigin);

  useEffect(() => {
    logger.error({
      event: 'Error in error.tsx',
      error,
      citOrigin
    });
    reportErrorDebounced(error, rollbar);
  }, [error, rollbar, citOrigin, logger]);

  return (
    <>
      <Navbar disableSearch={true} />
      <ErrorMessage
        message='Unexpected Error'
        subTitle='Oops! Something went wrong.'
        citOrigin={citOrigin}
      />
    </>
  );
}
